import { Link, useParams } from 'react-router-dom';
import ContactActions from '../components/ContactActions';
import CtaBand from '../components/CtaBand';
import GuideCard from '../components/GuideCard';
import Layout, { PageHero } from '../components/Layout';
import { categoryLabel, findGuide, guidesIn } from '../constants/guides';
import NotFound from './NotFound';

export default function GuideArticlePage() {
  const { slug } = useParams();
  const guide = findGuide(slug);
  if (!guide) return <NotFound />;

  const related = guidesIn(guide.category).filter((g) => g.slug !== guide.slug).slice(0, 3);

  return (
    <Layout>
      <PageHero
        eyebrow={categoryLabel(guide.category)}
        title={guide.title}
        lead={guide.summary}
        crumbs={[{ label: 'Guides', to: '/guides' }, { label: guide.title }]}
      />

      <section className="section">
        <div className="container article-grid">
          <article className="prose">
            <p className="article-meta">{guide.readTime}</p>
            {guide.sections.map((s) => (
              <section key={s.heading}>
                <h2>{s.heading}</h2>
                {s.body?.map((p) => (
                  <p key={p}>{p}</p>
                ))}
                {s.steps ? (
                  <ol className="steps">
                    {s.steps.map((step) => (
                      <li key={step}>{step}</li>
                    ))}
                  </ol>
                ) : null}
              </section>
            ))}
            <p className="note">
              Family Tree Maker menus can vary slightly between editions and operating systems. If what
              you see does not match these steps, our technicians can guide you live.
            </p>
          </article>

          <aside className="article-aside">
            <div className="aside-card">
              <h2>Still stuck?</h2>
              <p>Talk to a technician in live chat. Free guidance, no obligation.</p>
              <ContactActions chatLabel="Live Chat" />
            </div>
            <div className="aside-card aside-card--plain">
              <h2>More in this topic</h2>
              <ul>
                {guidesIn(guide.category).map((g) => (
                  <li key={g.slug}>
                    <Link to={`/guides/${g.slug}`} aria-current={g.slug === guide.slug ? 'page' : undefined}>
                      {g.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      {related.length ? (
        <section className="section section--parchment">
          <div className="container">
            <div className="section-head">
              <h2>Related guides</h2>
            </div>
            <div className="card-grid card-grid--3">
              {related.map((g) => (
                <GuideCard key={g.slug} guide={g} />
              ))}
            </div>
          </div>
        </section>
      ) : null}

      <CtaBand />
    </Layout>
  );
}
